import { render } from "./ReconUploadPayroll..vue?vue&type=template&id=32c47a48&scoped=true"
import script from "./ReconUploadPayroll..vue?vue&type=script&lang=js"
export * from "./ReconUploadPayroll..vue?vue&type=script&lang=js"

import "./ReconUploadPayroll..vue?vue&type=style&index=0&id=32c47a48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c47a48"]])

export default __exports__